import Collection from 'core/model/Collection';
import CompanyMessageModel from 'app/stores/sudo/CompanyMessageModel';

export default class CompanyMessagesCollection extends Collection {
  companyId;

  get defaultSortState() {
    return { field: 'expdate', direction: 'desc' };
  }

  constructor({ messages = [], companyId }) {
    super(messages);
    this.companyId = companyId || '';
  }

  get model() {
    return CompanyMessageModel;
  }

  get url() {
    return `/api/ui/sudo/messages/${this.companyId}`;
  }

  get urlPaths() {
    return {
      fetch: `/api/ui/sudo/messages/${this.companyId}`,
      update: `/api/ui/sudo/messages/${this.companyId}`,
      create: `/api/ui/sudo/messages/${this.companyId}`,
      destroy: `/api/ui/sudo/messages/${this.companyId}`
    };
  }
}
